export default __webpack_public_path__ + "static/media/floor-11.798cddde.jpg";